export class DeleteEmployeeModel {
  public employeeId: string;
}
